/**
 * Left pane of the Appeal Info modal: Case Details and History tabs.
 */

import { useState } from "react";

import { CaseAppealsTableRowData } from "../../../../data-model/caseAppealsTable";
import NonEpaTabBar from "../../nonEpaModal/components/nonEpaTabBar";
import CaseDetailsContent from "./caseDetailsContent";
import HistoryPane from "./historyPane";

enum CaseDetailsTab {
  DETAILS = "details",
  HISTORY = "history",
}

const TAB_CONFIG = [
  { id: CaseDetailsTab.DETAILS, label: "Case Details" },
  { id: CaseDetailsTab.HISTORY, label: "History" },
];

interface CaseDetailsPaneProps {
  data: CaseAppealsTableRowData;
}

/**
 * Left pane matching the Non-EPA modal layout. Shows read-only case details
 * or the appeal audit trail for the selected Case Appeals row.
 *
 * @param props.data - Appeal table row the modal was opened for
 * @returns Case details / history left pane
 */
const CaseDetailsPane = (props: CaseDetailsPaneProps) => {
  const [activeTab, setActiveTab] = useState<CaseDetailsTab>(
    CaseDetailsTab.DETAILS,
  );

  return (
    <div className="flex h-full min-h-0 flex-col">
      <NonEpaTabBar
        tabs={TAB_CONFIG}
        activeTabId={activeTab}
        onTabChange={(tabId) => setActiveTab(tabId as CaseDetailsTab)}
      />

      <div className="min-h-0 flex-1 overflow-y-auto">
        {activeTab === CaseDetailsTab.DETAILS && (
          <CaseDetailsContent data={props.data} />
        )}
        {activeTab === CaseDetailsTab.HISTORY && (
          <HistoryPane data={props.data} />
        )}
      </div>
    </div>
  );
};

export default CaseDetailsPane;
